import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="版本">{data.c_pdtversion}</Description>
          <Description term="qq主帐号">{data.c_account_main}</Description>
          <Description term="开通时间">{data.c_open_time}</Description>
        </Row>
        <Row>
          <Description term="到期时间">{data.c_end_time}</Description>
          <Description term="工位">{data.c_account_num}</Description>
          <Description term="服务类型">{data.qq_service}</Description>
        </Row>
        <Row>
          <Description term="服务费">{data.qq_service_money}</Description>
          <Description term="群发充值">{data.qq_message}</Description>
          <Description term="短信充值">{data.message}</Description>
        </Row>
        <Row>
          <Description term="类型">{data.c_type}</Description>
          <Description term="加减工号">{data.add_qq}</Description>
          <Description term="变更工号">{data.c_add_num}</Description>
        </Row>
        <Row>
          <Description term="费用">{data.c_money}</Description>
          <Description term="续费年限">{data.c_years}</Description>
          <Description term="赠送年限">{data.c_free}</Description>
        </Row>
        <Row>
          <Description term="保号费">{data.c_protect}</Description>
          <Description term="费用">{data.c_money}</Description>
          <Description term="微信制作费用">
            {data.weixinx_make_money}
          </Description>
        </Row>
        <Row>
          <Description term="是否认证">{data.wei_attest}</Description>
          <Description term="起始版本">{data.wei_version}</Description>
          <Description term="升级版本">{data.wei_version_up}</Description>
        </Row>
        <Row>
          <Description term="用户数">{data.c_email_num}</Description>
          <Description term="年数">{data.c_years}</Description>
          <Description term="费用">{data.email_money}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProQqSequel.js